export default {
  metadata: {
    version: '1.0.0',
    id: 'toggle-1.0.0',
    name: 'JDSToggle',
    description:
      'Interaction element for decision making that may or may not be accompanied by a label, depending on the context of use.'
  },
  hierarchy: {
    'vertical-container': [
      {
        'horizontal-container': [
          {
            'prefix-icon-container': [
              {
                'toggle-jds-icon-container': ['toggle-jds-icon']
              }
            ]
          },
          'left-jds-text',
          {
            'pill-container': ['ball-container']
          },
          'right-jds-text'
        ]
      },
      'jds_feedback_block',
      'helper-jds-text'
    ]
  },
  base: {
    'vertical-container': {
      hidden: false,
      'flex-direction': '{t_1}',
      'justify-content': '{t_2}',
      'align-items': '{t_3}',
      gap: '{t_4}',
      opacity: '{t_42}'
    },
    'horizontal-container': {
      hidden: false,
      'flex-direction': '{t_5}',
      'justify-content': '{t_6}',
      'align-items': '{t_7}',
      gap: '{t_8}',
      behavior: {
        hover: {},
        active: {},
        focus: {}
      }
    },
    'pill-container': {
      hidden: false,
      'min-width': '{t_9}',
      'min-height': '{t_10}',
      'flex-direction': '{t_11}',
      'justify-content': '{t_12}',
      'align-items': '{t_13}',
      'padding-left': '{t_14}',
      'padding-right': '{t_15}',
      'background-color': '{t_16}',
      'border-radius': '{t_17}',
      'border-width': '{t_18}',
      'border-color': '{t_19}',
      behavior: {
        hover: {
          'border-color': '{t_20}'
        },
        active: {
          'border-color': '{t_21}'
        },
        focus: {
          'border-width': '{t_24}',
          'box-shadow': {
            x: 0,
            y: 0,
            blur: 0,
            spread: '{t_22}',
            color: '{t_23}'
          }
        }
      }
    },
    'ball-container': {
      hidden: false,
      'min-width': '{t_25}',
      'min-height': '{t_26}',
      'background-color': '{t_27}',
      'border-radius': '{t_28}',
      show: true
    },
    'prefix-icon-container': {
      'flex-direction': '{t_0}'
    },
    jds_feedback_block: {
      size: 'l'
    },
    'left-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      'text-align': '{t_29}',
      'flex-fill-android': false,
      behavior: {
        hover: {
          color: '{text_20}'
        },
        focus: {
          color: '{text_20}'
        }
      }
    },
    'right-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true,
      behavior: {
        hover: {
          color: '{text_20}'
        },
        focus: {
          color: '{text_20}'
        }
      }
    },
    'toggle-jds-icon': {
      size: '{icon_5}',
      color: '{icon_15}'
    },
    'toggle-jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}'
    },
    'helper-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    }
  },
  variant: {
    size: {
      small: {
        'pill-container': {
          'min-width': '{t_30}',
          'min-height': '{t_31}'
        },
        'vertical-container': {
          gap: '{t_32}'
        },
        'ball-container': {
          'min-width': '{t_33}',
          'min-height': '{t_34}'
        },
        jds_feedback_block: {
          size: 's'
        },
        'left-jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        },
        'right-jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        },
        'toggle-jds-icon': {
          size: '{icon_22}'
        },
        'toggle-jds-icon-container': {
          size: '{icon_21}'
        },
        'helper-jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        }
      }
    },
    labelPosition: {
      right: {
        'left-jds-text': {
          hidden: true
        },
        'right-jds-text': {
          hidden: false
        }
      }
    },
    checked: {
      true: {
        'pill-container': {
          'justify-content': '{t_35}',
          'background-color': '{t_36}',
          'border-width': '{t_37}',
          behavior: {
            hover: {
              'background-color': '{t_38}'
            },
            active: {
              'background-color': '{t_39}'
            }
          }
        },
        'ball-container': {
          'background-color': '{t_40}'
        },
        'left-jds-text': {
          color: '{text_20}'
        },
        'right-jds-text': {
          color: '{text_20}'
        },
        'toggle-jds-icon': {},
        'toggle-jds-icon-container': {}
      }
    },
    disabled: {
      true: {
        'horizontal-container': {
          disabled: true
        },
        'prefix-icon-container': {
          disabled: true
        },
        'vertical-container': {
          opacity: '{t_41}'
        }
      }
    }
  },
  api: {
    config: {
      checked: {
        values: [false, true],
        doc_description:
          'It can be used to programatically make input active/inactive.'
      },
      labelPosition: {
        values: ['left', 'right'],
        doc_description:
          'It can be used to position lable to either left or right of Toggle.'
      },
      size: {
        values: ['medium', 'small'],
        doc_description: 'It can be used control the size of Toggle.'
      },
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable Toggle.'
      }
    },
    data: {
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText',
          doc_description:
            'It displays message with respect to its [state] selected.'
        },
        state: {
          type: 'JDSFeedbackBlock.state',
          name: 'state',
          doc_description:
            "It can be used to choose between states i.e. 'success','warning','error','none'."
        }
      },
      'left-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Toggle.'
        }
      },
      'right-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Toggle.'
        }
      },
      'toggle-jds-icon': {
        value: {
          type: 'icon',
          name: 'icon',
          doc_description: 'Take icon input for Toggle.'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText',
          doc_description: 'It displays helper text of Toggle.'
        }
      }
    },
    events: {
      'horizontal-container': {
        onClick: 'onClick'
      },
      'prefix-icon-container': {
        onClick: 'onPrefixClick'
      }
    },
    a11y: {
      'vertical-container': {
        properties: {
          role: {
            value: 'switch'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-checked': {
            name: '_ariaChecked',
            prop: 'checked'
          }
        }
      }
    }
  }
};
